import styled from 'styled-components'
// components
import { Scrollbar } from 'components/UI'
// themes
import { colors } from 'themes/index'

export const FiltersWrapper = styled(Scrollbar)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-right: 16px;

  > .MuiButtonBase-root {
    align-self: center;
    width: 48px;
  }
`

export const RuleWrapper = styled.div`
  align-items: center;
  border-radius: 4px;
  border: 1px solid gray;
  cursor: default;
  display: flex;
  justify-content: space-between;
  padding: 12px;
`

export const FieldName = styled.span`
  cursor: pointer;
  font-weight: 600;
`

export const Value = styled.span`
  font-weight: bold;
`

export const UnavailableField = styled.div`
  color: ${colors.red300};
  font-weight: bold;
`
